// extracted by mini-css-extract-plugin
export default {"advantagesWrapper":"styles_advantagesWrapper__YQYoM","colorsWrapper":"styles_colorsWrapper__y1zO0"};